import { NotAny } from '@mews/std';
import { useLocalizeEnum } from './useLocalizeEnum';

export const LocalizedEnum = <
    Prefix extends keyof Mews.EnumLocalization['prefixes'],
    Value extends Mews.EnumLocalization['prefixes'][Prefix]['valueType'],
>({
    prefix,
    value,
}: {
    prefix: Prefix;
    value: NotAny<Value>;
}) => <>{useLocalizeEnum()(prefix, value)}</>;
